import api from '../api';
import { defaultFetchListOptions } from './useQuery';
import type { FetchListOptions, User } from '../types/types';

export const useFetchUsers = () => {
  const fetchUsersByIds = async (userIds: string[], itemsPerPage = 10): Promise<User[]> => {
    const response = await api.fetchers.fetchUsers({
      ...defaultFetchListOptions,
      itemsPerPage,
      filters: {
        uids: userIds,
      },
    } as FetchListOptions);
    return response.data.data;
  };

  return {
    fetchUsersByIds,
  };
};
